import Reports from "../api/StaffReports";

export const storeReportsList = (reports) => ({
  type: "SET_REPORT_LIST",
  reports,
});

export const fetchReportsList = () => (dispatch) => {
  dispatch({ type: "SET_REPORT_LOADING", loading: true });
  Reports.getList()
    .then((response) => {
      if (response.result !== "success") {
        dispatch({
          type: "SET_REPORT_ERROR",
          error: response.errors[0] || "Something went wrong.",
        });
      }
      dispatch(storeReportsList(response.data));
      dispatch({ type: "SET_REPORT_LOADING", loading: false });
    })
    .catch((response) => {
      dispatch({
        type: "SET_REPORT_ERROR",
        error: response.errors[0] || "Something went wrong.",
      });
      dispatch({ type: "SET_REPORT_LOADING", loading: false });
    });
};

export const fetchReportDetails = (code) => (dispatch) => {
  dispatch({ type: "SET_DETAILS_ERROR", error: "" });
  dispatch({ type: "SET_DETAILS_LOADING", loading: true });
  Reports.getDetails(code)
    .then((response) => {
      dispatch({
        type: "ADD_REPORT_DETAILS",
        key: code,
        data: response.data.data || [],
      });
      dispatch({
        type: "SET_REPORT_STAFFWORKERS",
        staffworkers: response.data.data || [],
      });
      dispatch({ type: "SET_DETAILS_LOADING", loading: false });
    })
    .catch((response) => {
      dispatch({ type: "SET_DETAILS_LOADING", loading: false });
      dispatch({
        type: "SET_DETAILS_ERROR",
        error: response?.errors
          ? Object.values(response.errors)[0]
          : "Something went wrong.",
      });
    });
};

export const storeStaffworkers = (staffworkers) => (dispatch) => {
  dispatch({ type: "SET_DETAILS_ERROR", error: "" });
  dispatch({
    type: "SET_REPORT_STAFFWORKERS",
    staffworkers,
  });
  setTimeout(
    () => dispatch({ type: "SET_DETAILS_LOADING", loading: false }),
    200
  );
};

export const storeReportType = (reportType) => ({
  type: "SET_REPORT_TYPE",
  reportType,
});

export const storeSearchQuery = (query) => ({
  type: "SET_TABLE_SEARCH_QUERY",
  query,
});

export const storeSelectedProgrammeDetails = (details) => ({
  type: "SET_SELECTED_PROGRAMME_DETAILS",
  details,
});
